/**
 * /admin/preferences — layout route with sidebar + outlet.
 *
 * Auth provided by the parent _admin layout (beforeLoad token check).
 * D4: NarrowScreenNotice shown below 768px; actual content hidden at md:hidden.
 * Sidebar is 240px; main area is flex-1.
 */
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { NarrowScreenNotice } from '../../components/preferences/NarrowScreenNotice';
import { PreferencesSidebar } from '../../components/preferences/PreferencesSidebar';

export const Route = createFileRoute('/_admin/preferences')({
  component: PreferencesLayout,
});

function PreferencesLayout() {
  return (
    <>
      {/* D4: Narrow screen notice — visible only below 768px */}
      <NarrowScreenNotice />

      {/* Main layout — hidden on narrow screens */}
      <div className="hidden md:flex h-full flex-1">
        <PreferencesSidebar />
        <main className="flex-1 overflow-auto px-10">
          <Outlet />
        </main>
      </div>
    </>
  );
}
